import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { GroupsEnum } from "../../enum/groups.enum";
import { AuthService } from "../../services/auth.service";
import { ValidatorService } from "../../services/validator.service";
@Component({
  selector: "app-fiduci-proof",
  templateUrl: "./admin-fiduci-proof.component.html",
  styleUrls: ["./admin-fiduci-proof.component.scss"],
})
export class AdminFiduciProofComponent implements OnInit {
  @Input() ticketId: any = null;
  @Input() statusDescription: string = "";
  @Input() isManualSettlementDate: string = "";
  @Input() settlementDate: Date = null;
  @Input() administratorAnnotation: string = "";
  @Output() tempSettlementDate = new EventEmitter<Date>();
  @Output() tempAdministratorAnnotation = new EventEmitter<string>();

  fiduciGroup: number = GroupsEnum.AdmFiduci;
  groups = GroupsEnum;

  constructor(
    public validator: ValidatorService,
    public authService: AuthService
  ) {}

  @ViewChild("thisInput") inputFile: ElementRef;

  ngOnInit() {}

  keepEditable(): boolean {
    return (
      (this.isManualSettlementDate ?? false) &&
      this.authService.hasGroup([this.groups.AdmFiduci]) &&
      this.statusDescription == "Pendente de Aprovação pela ADM"
    );
  }

  emitSettlementDate() {
    this.tempSettlementDate.emit(this.settlementDate);
  }

  emitAdministratorAnnotation() {
    this.tempAdministratorAnnotation.emit(this.administratorAnnotation);
  }
}
